import { 
  collection, 
  doc, 
  getDocs, 
  addDoc, 
  updateDoc, 
  query, 
  where 
} from 'firebase/firestore'
import { db } from '../config'

export interface Profile {
  id?: string
  name: string
  description: string
  permissions: {
    [key: string]: boolean
  }
  menuPermissions: {
    [key: string]: boolean
  }
  color: string
  icon: string
  active: boolean
  createdAt: string
  updatedAt: string
}

export const getProfiles = async () => {
  const profilesRef = collection(db, 'profiles')
  const q = query(profilesRef, where('active', '==', true))
  const snapshot = await getDocs(q)
  
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  })) as Profile[]
}

export const createProfile = async (data: Omit<Profile, 'id' | 'active' | 'createdAt' | 'updatedAt'>) => {
  const profilesRef = collection(db, 'profiles')
  const now = new Date().toISOString()
  
  const docRef = await addDoc(profilesRef, {
    ...data,
    active: true,
    createdAt: now,
    updatedAt: now
  })

  return {
    id: docRef.id,
    ...data,
    active: true,
    createdAt: now,
    updatedAt: now
  } as Profile
}

export const updateProfile = async (id: string, data: Partial<Profile>) => {
  const profileRef = doc(db, 'profiles', id)
  const now = new Date().toISOString()
  
  await updateDoc(profileRef, {
    ...data,
    updatedAt: now
  })

  return {
    id,
    ...data,
    updatedAt: now
  } as Partial<Profile>
}

export const deleteProfile = async (id: string) => {
  const profileRef = doc(db, 'profiles', id)
  await updateDoc(profileRef, {
    active: false,
    updatedAt: new Date().toISOString()
  })
}

export const deleteDefaultProfiles = async () => {
  console.log('[Profiles Service] Iniciando exclusão de perfis default');
  
  try {
    const profilesRef = collection(db, 'profiles');
    const q = query(profilesRef, where('name', '==', 'default profile'));
    const snapshot = await getDocs(q);
    
    console.log(`[Profiles Service] Encontrados ${snapshot.size} perfis default`);
    
    const deletePromises = snapshot.docs.map(async (doc) => {
      console.log(`[Profiles Service] Excluindo perfil: ${doc.id}`);
      await deleteProfile(doc.id);
    });
    
    await Promise.all(deletePromises);
    console.log('[Profiles Service] Todos os perfis default foram excluídos');
    
    return snapshot.size;
  } catch (error) {
    console.error('[Profiles Service] Erro ao excluir perfis default:', error);
    throw error;
  }
};